// extracted by mini-css-extract-plugin
export default {"container":"WaveSpinnerContainer_container__1oWgv","spinner":"WaveSpinnerContainer_spinner__LK4sp","centerContainer":"WaveSpinnerContainer_centerContainer__Wba5S"};